module.exports = __webpack_public_path__ + "static/media/stars.321b1556.svg";